<template>
  <!-- 添加的弹窗 -->
  <div class="addDialog">
    <el-dialog
      width="50%"
      :title="dititle"
      :visible.sync="innerVisible"
      append-to-body
      @close="resetFormAddDialog"
    >
      <el-form
        :model="form"
        :rules="rules"
        ref="addDialogruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="模型图片" prop="imgList">
          <uploadImage
            :buttonName="'上传图片'"
            :img-file="form.imgList"
            :width="'224'"
            :height="'143'"
            :imgType="'img'"
            messSize='长需要为734px，宽需要为412px图片'
            @avatarChange="avatarChange($event)"
            @getDragImgFile="getDragImgFile($event)"
            @deleteImg="deleteImg($event)"
            :imgsBtn = "imgsBtn"
          ></uploadImage>
            <span style="color:#DCDFE6" >请上传长:734px,宽:412px的图片</span>
        </el-form-item>
        <el-form-item label="模型" prop="fileList">
          <uploadFile
            :limit="1"
            :buttonName="'上传模型'"
            :fileList="form.fileList"
            :fileType="'obj,stl,OBJ,STL'"
            :fileTypeMessage="'请上传类型为obj,stl的模型文件'"
            @fileListChange="fileListChange"
            @deleteFile="deleteFile"
            @getDragFile="getDragFile"
            :modelBtn = "modelBtn"
          ></uploadFile>
        </el-form-item>
        <el-form-item class="formButton">
          <el-button
            type="primary"
            @click="submitFormAdddialog('addDialogrules')"
            >添加</el-button
          >
          <el-button @click="resetFormAddDialog('addDialogrules')"
            >取消</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import uploadImage from "@/components/uploadImage";
import uploadFile from "@/components/uploadFile";
export default {
  data() {
    return {
      dititle:'',
      innerVisible: false,
      imgsBtn: true,
      modelBtn: true,
      imgType:'img',
      form: {
        imgList: [],
        fileList: [],
      },
      rules: {
        imgList: [
          {
            required: true,
            message: "请上传模型图片",
            trigger: ["change"],
          },
        ],
        fileList: [
          {
            required: true,
            message: "请上传模型文件",
            trigger: ["change"],
          },
        ],
      },
    };
  },
  components: {
    uploadImage,
    uploadFile,
  },
  methods: {
    init(type,mess) {
        console.log('dfa',type,mess );
      this.innerVisible = true;
        if(type == 'add'){
            this.dititle = "上传模型"
            this.form.imgList = []
            this.form.fileList = []

            this.modelBtn = true
            this.imgsBtn = true
        }else if(type == 'edi'){
            this.dititle = "修改模型"

            this.form.imgList.push({url:mess.url})
            this.form.fileList.push({name:mess.name, length:2131, mimeType: "",url:mess.modelUrl})

            this.modelBtn = false
            this.imgsBtn = false
        }
    },
    // 添加
    submitFormAdddialog(formName) {
        // console.log('eeeee',this.form.imgList[0].url,this.form.fileList[0].name );

      this.$refs.addDialogruleForm.validate((valid) => {
        if (valid) {
            let tabDialog = {
                url: this.form.imgList[0].url,
                name: this.form.fileList[0].name,
                modelUrl: this.form.fileList[0].url,
                fileType:'FILE',
                dititle: this.dititle
            }
          this.imgsBtn = true
          this.modelBtn = true
          this.innerVisible = false;
          this.$message({
            showClose: true,
            message: "添加成功！",
            type: "success",
          });
          this.$refs.addDialogruleForm.resetFields();
          this.$emit('tabDialogMess',tabDialog)
        } else {
          return false;
        }
      });
    },
    // 当前图片的个数
    imageListLength(val){
       if (val.length > 0 ) {
           this.imgsBtn = false
       }else {
           this.imgsBtn = true
       }
    },
    // 当前模型的个数
    modelListLength(val){
       if (val.length > 0 ) {
           this.modelBtn = false
       }else {
           this.modelBtn = true
       }
    },
    // 取消
    resetFormAddDialog(formName) {
      this.imgsBtn = true
      this.modelBtn = true
      this.innerVisible = false;

        this.form.imgList = []
        this.form.fileList = []
      // this.$refs.addDialogruleForm.resetFields();

    },
    // 上传成功
    avatarChange(val) {
      this.form.imgList = val;
      this.$refs.addDialogruleForm.validateField('imgList');
      this.imageListLength(val)
    },
    // 获取拖拽后的图片
    getDragImgFile(file) {
      if (file) {
        this.form.imgList = file;
      }
      this.$refs.addDialogruleForm.validateField('imgList');
      this.imageListLength(val)
    },
    // 删除图片
    deleteImg(val) {
      this.form.imgList = val;
      this.$refs.addDialogruleForm.validateField('imgList');
      this.imageListLength(val)
    },
    // 上传模型文件
    fileListChange(file) {
      this.form.fileList = file;
      this.$refs.addDialogruleForm.validateField('fileList');
      this.modelListLength(file)
    },
    // 删除模型文件
    deleteFile(file) {
      this.form.fileList = file;
      this.$refs.addDialogruleForm.validateField('fileList');
      this.modelListLength(file)
    },
    // 获取拖拽后的模型文件
    getDragFile(file) {
      this.form.fileList = file;
      this.$refs.addDialogruleForm.validateField('fileList');
      this.modelListLength(file)
    },
  },
};
</script>

<style lange="less">
.formButton {
    margin-top: 20px;
    text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/views/production/modelAddDialog.vue